import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;
export const publishProductReview = async (reviewId, currentState) => {
  // Toggle the state: if currently published (1), set to unpublished (0), otherwise vice versa.
  const newState = currentState === 1 ? 0 : 1;
  try {
    const response = await axios.post(
      `${baseUrl}/api/ColtecProduct/PublishProductReview`,
      {
        reviewId: reviewId,
        isPublished: newState,
      }
    );
    console.log(response, "Publish Product Review");
    // Optionally, check response data if needed.
    return newState;
  } catch (error) {
    console.error("Error updating publish status:", error);
    throw error;
  }
};
